import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-md border-t border-white/10 p-6 animate-in slide-in-from-bottom duration-500">
      <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex-1">
          <p className="text-white text-base leading-relaxed">
            Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern. Durch die Nutzung dieser Website stimmen Sie unserer{' '}
            <a href="/datenschutz" className="text-[#FF4444] hover:underline">
              Datenschutzerklärung
            </a>{' '}
            zu.
          </p>
        </div>
        <div className="flex items-center gap-4">
          <Button
            onClick={declineCookies}
            className="bg-white/10 text-white hover:bg-white/20 border-0 rounded-md px-6 py-3 h-auto text-base font-medium transition-all duration-300"
          >
            Ablehnen
          </Button>
          <Button
            onClick={acceptCookies}
            className="bg-[#FF4444] text-black hover:bg-[#FF6666] border-0 rounded-md px-6 py-3 h-auto text-base font-medium transition-all duration-300"
          >
            Akzeptieren
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;